"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMergedData = getMergedData;
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash.uniq"));

var _lodash2 = _interopRequireDefault(require("lodash.uniqby"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function getMergedData(nextData, previousData, config) {
  if (!previousData) {
    return nextData;
  }

  var isMergingDatum = config.isMergingDatum,
      isMutatingDatum = config.isMutatingDatum,
      resolve = config.resolve;
  var getDatumIdValue = config.getDatumIdValue || _utils.getDefaultDatumIdValue;
  var isMutatingArray = typeof config.isMutatingArray === 'undefined' ? true : config.isMutatingArray;
  var mergedData = isMutatingArray ? _toConsumableArray(previousData) : previousData; // for each datum we are going to assign (by merging or not) them into
  // their right place in the resolved array

  nextData.forEach(function (nextDatum) {
    var previousIndex = previousData.findIndex(function (previousDatum) {
      if (getDatumIdValue(previousDatum) === getDatumIdValue(nextDatum)) return true;

      if (typeof previousDatum.activityIdentifier !== 'undefined' && previousDatum.activityIdentifier !== null && typeof nextDatum.activityIdentifier !== 'undefined' && nextDatum.activityIdentifier !== null) {
        return previousDatum.activityIdentifier === nextDatum.activityIdentifier;
      }

      return false;
    });
    var previousDatum = previousData[previousIndex];
    var resolvedIndex = previousIndex === -1 ? mergedData.length : previousIndex;
    var datum;

    if (resolve) {
      datum = resolve(nextDatum, previousDatum, {
        previousData: previousData,
        nextData: nextData,
        config: config
      });
    } else if (isMutatingDatum) {
      datum = Object.assign({}, isMergingDatum && previousDatum, nextDatum);
    } else if (isMergingDatum) {
      datum = previousIndex !== -1 ? (0, _utils.merge)(previousDatum, nextDatum) : nextDatum;
    } else {
      datum = nextDatum;
    }

    if (previousDatum && previousDatum.__normalizers__ && nextDatum.__normalizers__) {
      datum.__normalizers__ = (0, _lodash2["default"])(previousDatum.__normalizers__.concat(nextDatum.__normalizers__), function (normalizer) {
        return "".concat(normalizer.datumKey || '', "-").concat(normalizer.stateKey || '');
      });
    }

    if (previousDatum && previousDatum.__tags__ && nextDatum.__tags__) {
      datum.__tags__ = (0, _lodash["default"])(previousDatum.__tags__.concat(nextDatum.__tags__));
    }

    mergedData[resolvedIndex] = datum;
  });
  return mergedData;
}

var _default = getMergedData;
exports["default"] = _default;